import type { Panel } from '@atlassian/preview-panels-api/types';

export const isNativeIssueViewPreviewPanel = (panel: Panel): boolean => {
	return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};
